import React, { Component } from 'react';
import { Button, Form, Input, UncontrolledAccordion, AccordionBody, AccordionHeader, AccordionItem, Table, Accordion, FormGroup } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink, Label, UncontrolledTooltip, Tooltip } from 'reactstrap';
import classnames from 'classnames';
import  TooltipItem  from '../../tools/TooltipItem';
import  EmpSearchData  from './searchModes/EmpSearchData';
import  DeptSearchData  from './searchModes/DeptSearchData';
import { GoCheck } from 'react-icons/go';
import moment from 'moment';
import { connect } from 'react-redux';

export class EmpDirBody extends Component {

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            loading: true,
            username: "",
            empResponse: [],
            accordionVisible: false,
            activeTab: '1',
            searchType: '',
            accordionPkList: [],
            lastSearch: [],
            permissionLevel: this.props.reduxData.userInfo.level.dept.substring(this.props.reduxData.userInfo.level.dept.indexOf("-") + 2),
            fullUserDept: this.props.reduxData.userInfo.level.pk,
            updateSuccess: false,
            activeDeptPK: [],
            deptWasChanged: false,
            refreshGo: '1',
            activeSearch: "EMP",
            fullList: [",", "."],
            individualSelect: ""
        }
        this.refreshSearch = this.refreshSearch.bind(this);
        this.getUserDeptPK(this.props.reduxData.userInfo.level.pk);
        
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //console.log("empdirbody userInfo level: " + this.props.reduxData.userInfo.level.pk)
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //this.props.updateFetchTime();
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false,
            username: this.props.reduxData.userInfo.username,
        });
        this.setState({
            permissionLevel: this.props.reduxData.userInfo.level.dept.substring(this.props.reduxData.userInfo.level.dept.indexOf("-") + 2),
            fullUserDept: this.props.reduxData.userInfo.level.pk
        });
        this.getUserDeptPK(this.props.reduxData.userInfo.level.pk);
    }

    async getUserDeptPK(dept) {//We only need one of the values this fetch returns, but we need it badly for a particular function. When a supervisor wants to change the name of their department,
                                //the new department name isn't told to the parts of the page that have to do with your active level, and therefore your permissions. Therefore, when the
                                //department name updates in the Departments table (and in the directory) but not in the permissions level system, changing the name is in effect revoking your
                                //ability to change your department information, at least until you refresh the page. This fetch gets the PK value of your active department so the ability to
                                //edit your department information can be governed by that instead of the plaintext name of the department.
                                //Updates to the way the data is stored have made this fairly useless since we're no longer letting users edit the department name, but this could be useful
                                //down the road
        let toSend = {
            userLevel: dept
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('GetUserDeptPK', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            activeDeptPK: data
        })
        this.radioClick("EMP");
    }

    componentDidMount() {
        
    }

    toggle(PK) {
        if (this.state.accordionPkList.indexOf(PK) <= -1) {
            this.setState(prevState => ({
                accordionPkList: [...prevState.accordionPkList, PK]
            }))
        }
        else {
            let currList = this.state.accordionPkList
            let index = currList.indexOf(PK)
            currList.splice(index, 1);
            this.setState({
                accordionPkList: currList
            })
        }
    }

    async findEmployees(e) {
        e.preventDefault(); //I'm still not sure what exactly this does, but I know including it here stops the whole page from breaking
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.setState({
            empResponse: [],
            accordionPkList: []
        })
        const query = new FormData(e.target);
        //if (query.get('searchInput') == "undefined") {//We will no longer allow empty searches. Look for someone.
        //    return;
        //}
        let searchFinal = "";
        if (query.get('searchInput') == "" && query.get('searchSelect') == "") {
            //console.log("caught");
            return;
        }
        else if (query.get('searchSelect') == "") searchFinal = query.get('searchInput');
        else searchFinal = query.get('searchSelect');
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            searchString: searchFinal,
            searchType: query.get('searchType')
        }
        //console.log("pinging: " + JSON.stringify(toSend));
        if (query.get('searchType') == 'EMP') {
            const response = await fetch('EmpDirLookup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                empResponse: data,
                accordionVisible: true,
                searchType: "EMP",
                lastSearch: toSend
            });
        }
        if (query.get('searchType') == 'DEPT') {
            const response = await fetch('DeptDirLookup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                empResponse: data,
                accordionVisible: true,
                searchType: "DEPT",
                lastSearch: toSend
            });
        }
        //localStorage.setItem("lastFetch", moment());
    }

    async refreshSearch() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = this.state.lastSearch;
        if (toSend.searchType == 'EMP') {
            const response = await fetch('EmpDirLookup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                empResponse: data,
                accordionVisible: true,
                searchType: "EMP",
                lastSearch: toSend,
                refreshGo: this.state.refreshGo + 1
            });
        }
        if (toSend.searchType == 'DEPT') {
            const response = await fetch('DeptDirLookup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                empResponse: data,
                accordionVisible: true,
                searchType: "DEPT",
                lastSearch: toSend,
                refreshGo: this.state.refreshGo + 1
            });
        }
        //localStorage.setItem("lastFetch", moment());
    }

    async updateDept(e, deptpk) {//This has been updated to no longer allow the user to edit the department name.
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        let toSend = {
            userLevel: this.state.activeDeptPK.deptpk,//This is the user's department PK instead of returnable.level because that value is the one being edited here
            deptpk: deptpk,
            newemail: dataInput.get('email')
        }
        const response = await fetch('UpdateDeptInfo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            updateSuccess: data,
            deptWasChanged: true
        })
        setTimeout(() => {
            this.setState({
                updateSuccess: false
            })
        }, 9000)
        this.refreshSearch();
    } 

    undoChange(deptpk) {
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            deptpk: deptpk
        }
        fetch('RevertDeptInfo', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(toSend) })
            .then((response) => { this.undoSuccess(!response); })
            .then((responseComplete) => { this.refreshSearch(); })
    }

    undoSuccess(response) {
        this.setState({
            deptWasChanged: response
            })
    }

    async radioClick(type) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.setState({
            activeSearch: type
        })
        //console.log("in radioclick returnable: " + JSON.stringify(this.props.reduxData.userInfo))
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            searchType: type
        }
        const response = await fetch('GetFullList', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            fullList: data
            })
    }

    createList(input) {
        this.setState({
            fullList: input
            })
    }

    async findEmployeesText() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.setState({
            empResponse: [],
            accordionPkList: []
        })
        if (this.state.textString == "" || this.state.textString == undefined) {
            return;
        }
        //console.log("find employees text: " + this.state.textString, ", " + this.state.activeSearch);
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            searchString: this.state.textString,
            searchType: this.state.activeSearch
        }
        if (this.state.activeSearch == 'EMP') {
            const response = await fetch('EmpDirLookup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                empResponse: data,
                accordionVisible: true,
                searchType: "EMP",
                lastSearch: toSend
            });
        }
        if (this.state.activeSearch == 'DEPT') {
            const response = await fetch('DeptDirLookup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                empResponse: data,
                accordionVisible: true,
                searchType: "DEPT",
                lastSearch: toSend
            });
        }
        //localStorage.setItem("lastFetch", moment());
    }

    async findEmployeesSelect() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.setState({
            empResponse: [],
            accordionPkList: []
        })
        //console.log("find employees text: " + this.state.individualSelect, ", " + this.state.activeSearch);
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            searchString: this.state.individualSelect,
            searchType: this.state.activeSearch
        }
        if (this.state.activeSearch == 'EMP') {
            const response = await fetch('EmpDirLookup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                empResponse: data,
                accordionVisible: true,
                searchType: "EMP",
                lastSearch: toSend
            });
        }
        if (this.state.activeSearch == 'DEPT') {
            const response = await fetch('DeptDirLookup', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                empResponse: data,
                accordionVisible: true,
                searchType: "DEPT",
                lastSearch: toSend
            });
        }
        //localStorage.setItem("lastFetch", moment());
    }

    //Because the department search needs to have multiple layers while the employee search does not, we use two different functional JSX blocks to render them.
    employeeSearchMode() {
        return (
            <div>
                <UncontrolledAccordion stayOpen defaultActiveKey="0" style={{ visibility: this.state.accordionVisible == true ? 'visible' : 'hidden' }} defaultOpen={[]}>
                    {this.state.empResponse.map(size => (
                        <AccordionItem>
                            <AccordionHeader targetId={size.pk}  >
                                <div id={size.name}>{size.name}</div>
                            </AccordionHeader>
                            <AccordionBody accordionId={size.pk}>
                                <EmpSearchData empSearch={this.state.empResponse[size.pk - 1].departmentList} callbackFunction={this.refreshSearch} key={this.state.refreshGo} />
                            </AccordionBody>
                        </AccordionItem>
                    ))}
                </UncontrolledAccordion>
            </div>
        );
    }

    departmentSearchMode() {
        return (
            <div>
                <UncontrolledAccordion stayOpen defaultActiveKey="0" style={{ visibility: this.state.accordionVisible == true ? 'visible' : 'hidden' }}>
                    {this.state.empResponse.map(size => (
                        <AccordionItem>
                            <TooltipItem id={"dept" + size.deptpk} title={"Division: " + size.parentname}>
                            <AccordionHeader targetId={size.deptpk} >
                                <div className="accordionHeader" >{size.name}</div>
                                </AccordionHeader>
                            </TooltipItem>
                            <AccordionBody accordionId={size.deptpk}>
                                {this.state.empResponse[size.pk - 1].people.map(peopleList => (
                                    <AccordionItem>
                                        <AccordionHeader targetId={peopleList.accordionpk}>
                                            {peopleList.name}
                                        </AccordionHeader>
                                        <AccordionBody accordionId={peopleList.accordionpk}>
                                            <DeptSearchData empSearch={this.state.empResponse[size.pk - 1].people[peopleList.pk - 1].departmentList} callbackFunction={this.refreshSearch} deptName={size.name} key={this.state.refreshGo} />
                                        </AccordionBody>
                                    </AccordionItem>
                                ))}
                                {(this.state.permissionLevel == "Supervisor" || this.state.permissionLevel == "Acting Supv")
                                    && this.state.activeDeptPK.deptpk == size.deptpk 
                                    &&
                                    <AccordionItem>
                                        <AccordionHeader targetId="CHANGEFORM">
                                            Change Department Information...
                                        </AccordionHeader>
                                        <AccordionBody accordionId="CHANGEFORM">
                                            <Form className='d-flex' onSubmit={(e) => this.updateDept(e, size.deptpk)}>
                                                <FormGroup> 
                                                    <Label>Department Email</Label>
                                                    <Input type="email" name="email" id="email" />
                                                </FormGroup>
                                                &emsp;
                                                <Button type="submit" outline color="success">Save</Button>&nbsp;<div style={{ visibility: this.state.updateSuccess == true ? 'visible' : 'hidden' }}>&emsp;Saved&nbsp;<GoCheck />
                                                </div>&emsp;
                                                {this.state.deptWasChanged == true && <Button outline color="warning" onClick={() => this.undoChange(size.deptpk)}>Undo</Button>}
                                            </Form>
                                        </AccordionBody>
                                    </AccordionItem>
                                }
                            </AccordionBody>
                        </AccordionItem>
                    ))}
                </UncontrolledAccordion>
            </div>
        );
    }

    render() {
            let displayInfo = <div></div>
            if (this.state.searchType == 'EMP') {
                displayInfo = this.employeeSearchMode()
            }
            else if (this.state.searchType == 'DEPT') {
                displayInfo = this.departmentSearchMode()
            }
        return (
            <div>
                <div>
                    <Form onSubmit={this.findEmployees.bind(this)}>
                        <div className="d-flex inlineCustom">
                            <Input type="radio" name="searchType" id="EMP" value="EMP" defaultChecked onClick={() => this.radioClick("EMP")} />&nbsp;<Label check>Employee</Label>&nbsp;&nbsp;&emsp;&emsp;<Input type="radio" name="searchType" id="DEPT" value="DEPT" onClick={() => this.radioClick("DEPT")} />&nbsp;<Label check>Department</Label>
                            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<div>
                                <Input type="select" name="searchSelect" id="searchSelect" value={this.state.individualSelect} onChange={(e) => this.setState({individualSelect: e.target.value})}>
                                <option value="">Choose a {this.state.activeSearch == "EMP" ? "Staff Member" : "Department"}</option>
                                {this.state.fullList.map(staff => (
                                    <option value={staff.pcid}>{staff.name}</option>
                                ))}
                            </Input>&emsp;&emsp;</div><div><Button onClick={(e) => this.findEmployeesSelect(e)}>Find This</Button></div>
                        </div>
                        <br />
                        <div className="d-flex">
                            <Input type="text" name="searchInput" id="searchInput" value={this.state.textString} onChange={e => this.setState({textString: e.target.value}) } />&nbsp;
                            <Button onClick={(e) => this.findEmployeesText(e)}>Search</Button>
                            </div>
                    </Form>
                </div>
                <br />
                {displayInfo}
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(EmpDirBody);